"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = ItemList;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@material-ui/core/styles");

var _List = _interopRequireDefault(require("@material-ui/core/List"));

var _Item = _interopRequireDefault(require("./Item"));

var _GenericStore = require("../store/GenericStore");

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _AddCircleOutline = _interopRequireDefault(require("@material-ui/icons/AddCircleOutline"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      width: '100%',
      maxWidth: 360,
      backgroundColor: 'transparent'
    },
    title: {
      textAlign: 'left',
      fontSize: '1.3em',
      width: '100%',
      fontWeight: 'bold',
      padding: '1.2em 0 0 0.8em',
      color: 'black'
    },
    ctnAddItem: {
      display: 'flex',
      flexDirection: 'row'
    },
    input: {
      flexGrow: 5,
      display: 'flex',
      alignItems: 'flex-end',
      paddingLeft: '1em'
    },
    add: {
      flexGrow: 1
    },
    addIcon: {
      color: '#FF9B39',
      transform: 'translateY(0.3em)'
    }
  };
});

function ItemList(props) {
  var parentPath = props.parentPath,
      _props$block = props.block,
      block = _props$block === void 0 ? {} : _props$block,
      _props$onSubmit = props.onSubmit,
      onSubmit = _props$onSubmit === void 0 ? function () {
    return null;
  } : _props$onSubmit,
      _props$isAutoSave = props.isAutoSave,
      isAutoSave = _props$isAutoSave === void 0 ? false : _props$isAutoSave,
      isLogInArray = props.isLogInArray;
  var title = block.title,
      placeholder = block.placeholder;
  var classes = useStyles();

  var _useDataStore = (0, _GenericStore.useDataStore)(parentPath + '/value', []),
      _useDataStore2 = (0, _slicedToArray2["default"])(_useDataStore, 2),
      values = _useDataStore2[0],
      setValues = _useDataStore2[1];

  var _useState = (0, _react.useState)(''),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      inputValue = _useState2[0],
      setInputValue = _useState2[1];

  var handleAdd = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var newValues;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(inputValue.trim().length === 0)) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              setInputValue('');
              newValues = [].concat((0, _toConsumableArray2["default"])(values), [inputValue]);
              _context.next = 6;
              return setValues(newValues);

            case 6:
              if (isAutoSave && !isLogInArray) onSubmit();

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleAdd() {
      return _ref.apply(this, arguments);
    };
  }();

  var handleRemove = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(index) {
      var newValues;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              newValues = values.slice();
              newValues.splice(index, 1);
              _context2.next = 4;
              return setValues(newValues);

            case 4:
              if (isAutoSave && !isLogInArray) onSubmit();

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleRemove(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleInputChange = function handleInputChange(e) {
    setInputValue(e.target.value);
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.ctnAddItem
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.input
  }, /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
    value: inputValue,
    onChange: handleInputChange,
    variant: 'standard',
    fullWidth: true,
    placeholder: placeholder || 'Hier eintragen:'
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.add
  }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    "aria-label": "confirm",
    onClick: handleAdd
  }, /*#__PURE__*/_react["default"].createElement(_AddCircleOutline["default"], {
    fontSize: 'large',
    className: classes.addIcon
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.title
  }, title || 'Meine Liste: '), /*#__PURE__*/_react["default"].createElement(_List["default"], {
    component: "nav",
    "aria-label": "main mailbox folders"
  }, values === null || values === void 0 ? void 0 : values.map(function (value, index) {
    return /*#__PURE__*/_react["default"].createElement(_Item["default"], {
      key: "".concat(value, "-").concat(index),
      onRemove: handleRemove,
      value: value,
      index: index
    });
  })));
}